import ListVariable from './list-variable-view';

const ListingVariablePage = {
    name: 'ListingVariable',
    list: ListVariable
};
export default ListingVariablePage;